import { defineComponent, computed } from 'vue';
import { pad } from '@/utils';
export default defineComponent({
  name: 'Countdown',
  props: {
    title: {
      type: String,
      default: ''
    },
    time: {
      type: Number,
      default: 0
    }
  },
  setup: function (props) {
    var data = computed(function () {
      var time = props.time;
      var second = time % 60;
      var minute = (time - second) / 60 % 60;
      var hour = ((time - second) / 60 - minute) / 60;
      return {
        hour: pad(hour),
        minute: pad(minute),
        second: pad(second)
      };
    });
    return {
      data: data
    };
  }
});